<template>
    <div class="automation-attribute-picker">
        <div class="btnGroup">
            <SupsisButton
                :classNames="selectedContext === context ? 'btnGroupItem selected' : 'btnGroupItem '"
                :primary="selectedContext === context"
                :ghost="selectedContext !== context"
                @click="() => changeSelectedContext(context)"
                small
                v-for="context in allowedContexts"
                :key="context"
            >
                {{ $_.startCase(context) }}
            </SupsisButton>
        </div>
        <div class="search-panel">
            <input maxlength="128" :placeholder="$t('chatbotv2.typeSearchValue')" type="text" v-model="searchText" />
            <span class="material-icons"> search </span>
        </div>
        <div class="filter-menu">
            <SupsisButton v-if="this.selectedMenu.length" ghost small @click="prev">
                <span class="material-icons"> chevron_left </span>
            </SupsisButton>
            <div class="breadcrump-item" v-for="menu of this.selectedMenu">
                <span> {{ $_.get(findAttributeByValue(menu), "label") }} ✦ </span>
            </div>
        </div>
        <div class="attribute-list">
            <div class="attr-select">
                <div
                    data-checked="true"
                    data-index="0"
                    data-item-label="Name"
                    class="picker-item"
                    v-for="attr of filterAttributes()"
                    @click="() => select(attr.value)"
                    :class="{ active: defaultSelected === attr.value }"
                >
                    <AttributeIconPreview :attribute="attr.value" />

                    <span class="name">
                        {{ attr.label }}
                    </span>
                    <span class="description">
                        {{
                            attr.placeholder == "Turkey" && attr.placeholder == "Male"
                                ? $t(`chatbotv2.${attr.placeholder.toLocaleLowerCase()}`)
                                : attr.placeholder
                        }}
                    </span>
                </div>
            </div>
            <hr />
            <!--            <AddCustomAttribute :on-added="pick" />-->
        </div>
    </div>
</template>

<script>
import AddCustomAttribute from "../../common/AddCustomAttribute.vue";
import AttributeIconPreview from "../../common/AttributeIconPreview.vue";
import { mapGetters, mapState } from "vuex";
import log2 from "../../../../../../../utils/log2";
import AutomationAttributesGenerator from "../../../../utils/AutomationAttributesGenerator";
import SupsisButton from "../../../../../Settings/components/SupsisButton.vue";

const log = log2("AutomationAttributePicker");
export default {
    name: "AutomationAttributePicker",
    components: {
        SupsisButton,
        AddCustomAttribute,
        AttributeIconPreview,
    },
    props: {
        defaultSelected: {
            type: String,
            required: false,
        },
        pick: {
            type: Function,
            required: true,
        },
        filterMode: {
            type: Boolean,
            required: false,
            default: false,
        },
        allowedAttributes: {
            type: Array,
            default: () => [],
        },
        allowedContexts: {
            type: Array,
            default: () => [
                //"contact",
                "block",
                "event",
                "system",
                "custom",
                "webhook",
                //"ticket",
            ],
        },
        prefix: {
            type: String,
        },
    },
    data() {
        return {
            searchText: "",
            attributes: [],
            selectedContext: "block",
            selectedMenu: [],
        };
    },
    computed: {
        ...mapState({
            visitorContactAttributes: (state) => state.contactProperty.data || [],
            automation: (state) => state.automation.current,
        }),
    },
    created() {
        console.log("created payload..", { automation: this.automation, prefix: this.prefix });
        this.attributes = AutomationAttributesGenerator.create().list(this.automation, this.prefix);
        console.log("created attributes..", { attributes: this.attributes });
        const data = this.getDefaultContext();
        this.selectedContext = data.context;
        this.selectedMenu = data.menuSelections;
    },

    methods: {
        getDefaultContext() {
            const attr = this.defaultSelected || "";
            console.log("getDefaultContext", { attr });
            if (attr.includes(".")) {
                const context = attr.split(".")[0];
                const path = attr.split("$")[0];
                const dotCount = path.split(".").length - 1;
                let menuSelections = [];
                if (dotCount > 1) {
                    for (let i = 1; i < dotCount; i++) {
                        menuSelections.push(
                            path
                                .split(".")
                                .slice(0, i + 1)
                                .join(".")
                        );
                    }
                }

                return {
                    context,
                    menuSelections,
                };
            }
            return {
                context: "block",
                menuSelections: [],
            };
        },
        isLocalizedAttribute(attribute) {
            return true;
        },
        changeSelectedContext(context) {
            this.searchText = "";
            this.selectedContext = context;
        },
        filterAttributes() {
            const parentAttribute = this.getParentAttribute();
            const parentAttributeContext = parentAttribute?.value.split(".")[0];
            const contextChanged = this.selectedContext !== parentAttributeContext;
            log("filterAttributes", { contextChanged, parentAttributeContext, parentAttribute });
            const systemContext = ["contact", "block", "event", "system", "custom", "webhook"];

            let attrs =
                parentAttribute && !contextChanged
                    ? parentAttribute.subAttributes
                    : this.attributes.filter((x) => x.context === this.selectedContext);
            if (parentAttribute && !systemContext.includes(parentAttributeContext))
                attrs = parentAttribute.subAttributes;
            return attrs.filter((attr) => {
                if (this.searchText) {
                    return (attr.label || "").toLowerCase().includes((this.searchText || "").toLowerCase());
                }
                return true;
            });
        },
        getParentAttribute() {
            const attributes = this.getFlatAttributes();
            const parent = this.selectedMenu[this.selectedMenu.length - 1];
            return attributes.find((x) => x.value === parent);
        },
        prev() {
            this.searchText = "";
            this.selectedMenu.pop();
        },
        findAttributeByValue(value) {
            const attributes = this.getFlatAttributes();
            return attributes.find((x) => x.value === value);
        },
        getFlatAttributes() {
            const flat = (attr) => {
                if (attr.subAttributes) {
                    return [attr, ...attr.subAttributes.flatMap(flat)];
                }
                return [attr];
            };
            return this.attributes.flatMap(flat);
        },
        select(value) {
            const attributes = this.getFlatAttributes();
            const attr = attributes.find((x) => x.value === value);
            log("select", { value, attr });
            this.searchText = "";
            if (Array.isArray(attr.subAttributes) && attr.subAttributes.length) {
                this.selectedMenu.push(value);
            } else {
                this.pick(value);
            }
        },
    },
};
</script>

<style lang="scss">
.automation-attribute-picker {
    background: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    max-height: 600px;
    min-height: 200px;
    user-select: none;
    width: 100%;
    padding: 5px;

    .filter-menu {
        display: flex;
        align-items: center;
        gap: 3px;

        .supsis-button {
            border: none !important;
            font-size: 13px;
            height: 25px;
        }

        .breadcrump-item {
            display: flex;
        }
    }

    .btnGroup {
        display: flex;
        border: 1px solid var(--color-border-default);
        border-radius: 6px;
        background: var(--color-bg-neutral-default);
        margin: 2px 10px;
        padding: 2px;

        .btnGrupItem {
            &.selected {
                background: var(--color-bg-oncomponent-default);
                box-shadow: var(--shadow-interaction-200);
            }
        }

        .supsis-button {
            border: none !important;
            font-size: 13px;
            height: 25px;
        }
    }

    .search-panel {
        align-items: center;
        border-bottom: 1px solid #e8eef3;
        display: flex;
        flex-shrink: 0;
        position: relative;
        width: 100%;

        input {
            background: transparent;
            border: 0;
            font-size: 16px;
            height: 40px;
            line-height: 20px;
            padding-left: 45px;
            padding-right: 15px;
            width: 100%;
        }

        span {
            color: #9ba6b3;
            font-size: 18px;
            left: 15px;
            pointer-events: none;
            position: absolute;
            -webkit-transition: color 0.3s;
            transition: color 0.3s;
        }
    }

    .attribute-list {
        flex-grow: 1;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 15px 15px;
        margin: 0px 5px 0px 5px;
        gap: 10px;

        .attr-select {
            margin-bottom: 10px;
        }
    }

    .picker-item {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        cursor: pointer;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 32px;
        padding: 0 5px;
        -webkit-transition: background-color 0.2s, opacity 0.2s;
        transition: background-color 0.2s, opacity 0.2s;

        &.active {
            color: #006cff !important;

            .material-icons,
            .name,
            .description {
                color: #006cff !important;
            }
        }

        &:hover {
            background-color: #f0f4f7;
        }

        .material-icons,
        .custom-attr-logo {
            color: #647283;
            font-size: 25px;
            margin-right: 11px;
        }

        .name {
            color: #22272d;
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            margin-right: 30px;
        }

        .description {
            color: #9ba6b3;
            font-size: 15px;
            line-height: 19px;
            margin-left: auto;
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}
</style>
